import React, { createContext, useContext, useEffect, useState } from "react";
import api, { fmtIDR } from "./api";

export const fmtUSD = (n) => {
  const v = Number(n) || 0;
  const tiny = v !== 0 && Math.abs(v) < 0.01;
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD",
    ...(tiny ? { minimumSignificantDigits: 2, maximumSignificantDigits: 2 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }).format(v);
};
export const usdtAmount = (idr, rate) => Math.ceil(Math.round((idr / rate) * 100 * 1e6) / 1e6) / 100;
export const fmtUSDT = (n) => `${(Number(n) || 0).toFixed(2)} USDT`;
export const USD_UNAVAILABLE = "USD unavailable";
export const paypalFee = (amount, pct) => (pct && amount > 0 ? Math.round((amount * pct) / 100) : 0);

const Ctx = createContext({ currency: "IDR", fx: null, money: fmtIDR, altMoney: () => USD_UNAVAILABLE, setCurrency: () => {}, refreshFx: async () => {} });

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => (localStorage.getItem("mql_currency") === "USD" ? "USD" : "IDR"));
  const [fx, setFx] = useState(null);

  useEffect(() => { localStorage.setItem("mql_currency", currency); }, [currency]);
  const refreshFx = () => api.get("/fx").then((r) => setFx(r.data)).catch(() => {});
  useEffect(() => {
    const load = refreshFx;
    load();
    const timer = setInterval(load, 60 * 60 * 1000);
    return () => clearInterval(timer);
  }, []);

  const money = (idr) => (currency === "USD" && fx ? fmtUSD(idr / fx.rate) : fmtIDR(idr));
  const altMoney = (idr) => (currency === "USD" && fx ? fmtIDR(idr) : fx?.rate > 0 ? `≈ ${fmtUSD(Number(idr) / fx.rate)}` : USD_UNAVAILABLE);
  return <Ctx.Provider value={{ currency, setCurrency, fx, money, altMoney, refreshFx }}>{children}</Ctx.Provider>;
}

export const useCurrency = () => useContext(Ctx);
